import styled from "styled-components";

import colorsTheme from "@style/colors";
export const style : React.CSSProperties = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: "400px",
	backgroundColor: colorsTheme.white,
	borderRadius: "8px",
	boxShadow: "0px 8px 24px rgba(0,0,0,0.15)",
	padding: "15px",
	outline: "none",
};

interface ITitleContainerProps {
	$align?: "left" | "center" | "right";
}

export const TitleContainer = styled.h3<ITitleContainerProps>`
	font-weight: bold;
	color: "#000";
	font-size: 1.5rem;
	text-align: center;
`;

export const SubtitleContainer = styled.p`
	font-size: 0.95rem;
	font-weight: 400;
	margin-top: 1rem;
	text-align: center;
`;
export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
`;
